import { defineComponent } from "@vue/composition-api";
import { GenericModal } from "@Shared/components/modals";
export default defineComponent({
  name: "DeleteComponentModal",
  components: {
    GenericModal
  },
  props: {
    message: {
      type: String,
      default: ""
    }
  },
  setup() {},
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    }
  }
});